/**
 * 数字/利率 相关方法集
 * jetty 2018-08
 * */
import check from './check'
export default {
    getExactNum (val, count) {
        if (check.isNull(val)) {
            return val
        }
        var deciLength = count || 7
        var decimals = val.toString().split('.')
        if (decimals[1] && decimals[1].length > deciLength) {
            return this.getFixed(val, deciLength) / 1
        }
        return val / 1
    },
    getFixed (value, level) {
        if (check.isNull(value)) {
            return value
        }
        var result = value / 1
        return '' + parseInt(result * Math.pow(10, level) + 0.5) / Math.pow(10, level)
    },
    /**
     * 获取总利息和
     * @business
     * */
    getTotalInterest (amount, periods, feeRate) {
        return this.getExactNum(amount * periods * feeRate)
    },
    /**
     * （等额本息）利息滞纳金收取
     * @param {
     *      capital: '本金',
     *      lateFeeRate: '逾期利率',
     *      lateDays: '逾期天数',
     * }
     * */
    getACPILateFees (capital, lateFeeRate, lateDays) {
        return this.getExactNum(capital * lateFeeRate / 365 * lateDays, 2)
    },
    /**
     * 获取（等额本息）手续费总额
     * @business
     * @param  {
     *      amount: '贷款总额',
     *      periods: '分的期数',
     *      feeRate: '每期费率',
     * }
     * */
    getACPIFee (amount, periods, feeRate) {
        let periodMoney = this.getACPIPeriodMoney(amount, periods, feeRate)
        let totalInterest = this.getTotalInterest(amount, periods, feeRate)
        return this.getExactNum(totalInterest - (periodMoney * periods - amount))
    },
    /**
     * 获取（等额本金）手续费总额
     * @business
     * @pram {
     *      amount: '贷款总额',
     *      periods: '分的期数',
     *      feeRate: '每期费率',
     * }
     * */
    getACFee (amount, periods, feeRate) {
        let periodsMoneyList = this.getACPeriodsMoneyList(amount, periods, feeRate)
        let total = 0
        periodsMoneyList.forEach((pm) => {
            total += pm.money
        })
        let totalInterest = this.getTotalInterest(amount, periods, feeRate)
        return this.getExactNum(totalInterest - (total - amount))
    },
    /**
     * 用年利率获取月利率
     * @base
     */
    getY2MFeeRate (feeRate) {
        return feeRate / 12
    },
    /**
     * 获取（等额本息）每期还款金额
     * @base
     * @param  {
     *      amount: '贷款总额',
     *      periods: '分的期数',
     *      feeRate: '每期费率',
     *      reamount: '已还款额',
     * }
     * @return {
     *      capital: '本金',
     *      interest: '利息',
     *      money: '总额',
     * }
     * */
    getACPIPeriodMoney (amount, periods, feeRate, reamount = 0) {
        let money = this.getExactNum(amount * feeRate * Math.pow((1 + feeRate), periods) / (Math.pow((1 + feeRate), periods) - 1), 2)
        let interest = this.getExactNum((amount - reamount) * feeRate, 2)
        let capital = this.getExactNum(money - interest, 2)
        return {money: money, capital: capital, interest: interest}
    },
    /**
     * 获取（等额本息）还款列表
     * @base
     * @pram {
     *      amount: '贷款总额',
     *      periods: '分的期数',
     *      feeRate: '每期费率',
     * }
     * @return [{
     *      period: '期数',
     *      capital: '本金',
     *      interest: '利息',
     *      money: '总额',
     * }]
     * */
    getACPIPeriodsMoneyList (amount, periods, feeRate) {
        let list = []
        let reamount = 0
        for (let i = 0; i < periods; i++) {
            let period = this.getACPIPeriodMoney(amount, periods, feeRate, reamount)
            reamount = this.getExactNum(reamount + period['capital'])
            period['period'] = i + 1
            list.push(period)
        }
        return list
    },
    /**
     * 获取（等额本金）每期还款金额
     * @base
     * @param {
     *      amount: '贷款总额',
     *      periods: '分的期数',
     *      feeRate: '每期费率',
     *      reamount: '已还款金额',
     * }
     * @return {
     *      capital: '本金',
     *      interest: '利息',
     *      money: '总额',
     * }
     * */
    getACPeriodMoney (amount, periods, feeRate, reamount) {
        let capital = this.getExactNum(amount / periods, 2)
        let interest = this.getExactNum((amount - reamount) * feeRate, 2)
        let money = this.getExactNum(((amount / periods) + (amount - reamount) * feeRate), 2)
        if (capital + interest != money) { // 意外打印
            console.log('等额本金每期金额:', capital, interest, money)
        }
        return {money: money, capital: capital, interest: interest}
    },
    /**
     * 获取（等额本金）还款列表
     * @base
     * @pram {
     *      amount: '贷款总额',
     *      periods: '分的期数',
     *      feeRate: '每期费率',
     * }
     * @return [{
     *      period: '期数',
     *      capital: '本金',
     *      interest: '利息',
     *      money: '总额',
     * }]
     * */
    getACPeriodsMoneyList (amount, periods, feeRate) {
        let list = []
        let reamount = 0
        for (let i = 0; i < periods; i++) {
            let period = this.getACPeriodMoney(amount, periods, feeRate, reamount)
            reamount = this.getExactNum(reamount + period['capital'])
            period['period'] = i + 1
            list.push(period)
        }
        return list
    }
}
